<template>
<div class="wrap flex-column">
    <mu-infinite-scroll :loading="load" loadingText="拼命加载中" class="load" v-if="load"/>
    <div class="flex-item" v-if=" !load">
      <div class="pay-result-box">
       <p>订单支付成功！</p>
      </div>
      <div class="pay-result">
        <p>订单号：{{payResult && payResult.orderNo}}</p>
        <p>支付方式：<label class="primary">{{payResult && payResult.payTypeName}}</label></p>
        <p>订单金额：<label class="primary">{{payResult && payResult.payAmount}}</label></p>
      </div>
      <div class="fullbtn-box">
        <mu-raised-button fullWidth  @click="gotoOrderDetail" v-if="payResult.orderFlag == 2" class="full gray" label="查看订单详情" />
        <mu-raised-button fullWidth  @click="gotoOrder" v-if="payResult.orderFlag == 1" class="full gray" label="查看订单"/>
      </div>
      <div class="fullbtn-box">
        <mu-raised-button label="继续逛逛" fullWidth  @click="goScanmore" class="full"/>
      </div>
    </div>
</div>
</template>
<script type="text/javascript">
import {
  mapActions,
  mapGetters
} from 'vuex';
import { storage } from "@common/utils/util.js";
  export default{

    data () {
      return {
          load:true,
          orderNO:this.$route.query.orderId,
          payResult:{},//订单信息
      }
    },
    computed:{

    },
    methods: {
        ...mapActions({
            getOrderPayResult: 'getOrderPayResult', //获取支付结果
        }),
        //跳转订单详情
        gotoOrderDetail() {
          this.$router.push({ path: '/main/orderdetail?stOrderId='+ this.payResult.orderNo +'&orderState=1'});
          return;
        },
        //跳转订单
        gotoOrder() {
          this.$router.push({ path: '/main/myorders?type=3'});
          return;
        },
        getPayResult(){
            this.getOrderPayResult([this.orderNO]).then(res => {
              this.payResult = res;
              this.load = false
              storage.local.remove('createOrderData')
            }).catch(error => {
              this.$message.error(error);
            })
        },
        goScanmore(){
          this.$router.push({ path: '/'});
        }
    },
    created(){
       
    },
    components:{
     
    },
    mounted() {
        storage.local.remove('invoiceData');
        storage.local.remove('orderData');
        this.getPayResult();
    },
  }
</script>
<style lang="scss" rel="stylesheet/scss">
@import 'src/common/sass/mixin.scss';
  .pay-result-box{
    text-align: center;
    background: #fff;
    p{
      display: inline-block;
      background: url(/static/images/pay_access_3x.png) no-repeat 0.3rem center;
      background-size: 1.5rem auto;
       @include font-dpr(20px);
      height: 3rem;
      line-height: 3rem;
      padding-left: 2rem;
    }
  }
  .pay-result{
    line-height: 1.5;
    color: #333333;
    @include font-dpr(14px);
    margin: 0.35rem;
  }
</style>


// WEBPACK FOOTER //
// paysuccess.vue?28474412